import { DirectTreasuryDetailsItemProps } from '../..';

export const parseDetailsItemData = (item: DirectTreasuryDetailsItemProps) => {
  return [
    { label: 'Data da compra', value: item.purchaseDate },
    { label: 'Quantidade', value: item.actualBalance },
    { label: 'Preço de compra', value: item.purchasePrice },
    { label: 'Valor investido', value: item.investedValue },
    { label: '% Contratada', value: item.agreedRate },
    { label: 'Valor bruto', value: item.grossValue },
    { label: '% acumulado', value: item.accumulatedProfitability },
    { label: 'Dias corridos', value: item.calendarDays },
    { label: '%IR', value: item.irTaxRate },
  ];
};

export const parseExtraDetailsItemData = (item: DirectTreasuryDetailsItemProps) => {
  return [
    { label: 'IR(R$)', value: item.irValue },
    { label: 'IOF(R$)', value: item.iofValue },
    { label: 'Custódia CBLC', value: item.cblcCustodyFee },
    { label: 'Custódia corretora', value: item.custodyFeeBroker },
    { label: '% Mês', value: item.profitabilityMonth },
    { label: '% Ano', value: item.profitabilityYear },
    { label: '% 12 meses', value: item.profitabilityTwelveMonths },
    { label: 'Valor líquido', value: item.netValue },
  ];
};
